<template>
    <v-row class="align-center d-flex flex-nowrap">
        <v-col cols="auto">
            <span>{{ batteryPercentage || 0 }}%</span>
        </v-col>
        <v-col cols="auto" class="pa-0" style="width:30px;">
            <v-progress-linear :value="batteryPercentage" height="20" rounded striped
                :color="batteryColor"></v-progress-linear>
        </v-col>
        <v-col cols="1" class="pl-0">
            <v-sheet height="12px" width="5px" class="grey darken-2"></v-sheet>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        batteryPercentage: {
            type: Number,
            required: true
        }
    },
    computed: {
        batteryColor() {
            if (this.batteryPercentage < 20) return 'red';
            if (this.batteryPercentage < 40) return 'orange';
            return 'green';
        }
    }
}
</script>

<style></style>